import { render, staticRenderFns } from "./hqglZcJIaofuspMainDetail.vue?vue&type=template&id=a06e907a&scoped=true&"
import script from "./hqglZcJIaofuspMainDetail.vue?vue&type=script&lang=js&"
export * from "./hqglZcJIaofuspMainDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglZcJIaofuspMainDetail.vue?vue&type=style&index=0&id=a06e907a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06e907a",
  null
  
)

export default component.exports